import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../Sections/Logo/Logo';
import filestack from 'filestack-js';
import { commitMutation, graphql } from 'react-relay';
import { Analytics, GlobalNotifications, Intent } from '../../Modules';

const apikey = process.env.FILESTACK_API_KEY;
const client = filestack.init(apikey);

export default class FormLogo extends React.Component {

  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    node: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.updateFormLogo = this.updateFormLogo.bind(this);
    this.uploadLogo = this.uploadLogo.bind(this);
    this.openPicker = this.openPicker.bind(this);
    this.deleteLogo = this.deleteLogo.bind(this);
  }

  updateFormLogo(successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to update logo',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      if (successCb) successCb();
      Analytics.trackEvent('updated-brand');
    };

    const mutation = graphql`
      mutation Logo_updateFormBrandMutation(
        $input: UpdateFormBrandInput!
      ) {
        updateFormBrand(input: $input) {
          form {
            id
            brand_logo_url
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          form_id: this.props.node.id,
          brand_id: this.props.viewer.primary_brand.id
        }
      },
      onCompleted,
      onError
    });
  }

  uploadLogo(fields) {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to upload logo',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      this.updateFormLogo();
      Analytics.trackEvent('uploaded-logo');
    };

    const mutation = graphql`
      mutation Logo_Form_Logo_updateBrandMutation($input: UpdateBrandInput!) {
        updateBrand(input: $input) {
          brand {
            id
            logo_url
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          logo_handle: fields.handle,
          logo_mimetype: fields.mimetype,
          logo_size: fields.size,
          logo_url: fields.url,
          id: this.props.viewer.primary_brand.id
        }
      },
      onCompleted,
      onError
    });
  }

  openPicker() {
    client
      .pick({
        maxFiles: 1,
        maxSize: 250000000,
        fromSources: ['local_file_system'],
        storeTo: {
          location: 's3'
        },
        accept: ['image/png', 'image/jpeg']
      })
      .then(res => {
        res.filesUploaded.map(file => {
          this.uploadLogo({
            name: file.filename,
            url: `https://s3.amazonaws.com/cb-user-uploads/${file.key}`,
            mimetype: file.mimetype,
            size: file.size,
            handle: file.handle
          });
          return file;
        });
      });
  }

  deleteLogo() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to delete logo',
        intent: Intent.DANGER
      });
    };

    const onCompleted = () => {
      this.updateFormLogo();
      Analytics.trackEvent('deleted-logo');
    };

    const mutation = graphql`
      mutation Logo_Form_deleteLogo_updateBrandMutation($input: UpdateBrandInput!) {
        updateBrand(input: $input) {
          brand {
            id
            logo_url
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          logo_handle: null,
          logo_mimetype: null,
          logo_size: null,
          logo_url: null,
          id: this.props.viewer.primary_brand.id
        }
      },
      onCompleted,
      onError
    });
  }

  render() {
    return (
      <Logo
        canEdit={this.props.canEdit}
        deleteLogo={this.deleteLogo}
        url={this.props.node.brand_logo_url}
        openPicker={this.openPicker}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Logo.js